var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorsArrowSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 14,
    viewBox: "0 0 717 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.58675H715M2 6.58675L7.5 0.746094M2 6.58675L7.5 12.7534M715 6.58675L709.335 1.25342M715 6.58675L709.335 13.2534",
    stroke: "#8F8F8F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorsArrowSvg);
export default __webpack_public_path__ + "static/media/indoors_arrow_svg.f541fa069c951555149ab79b287f90aa.svg";
export { ForwardRef as ReactComponent };